<script setup lang="ts">
withDefaults(
  defineProps<{
    backLabel?: string
    description?: string
    eyebrow: string
    title: string
  }>(),
  {
    backLabel: '返回会员中心',
    description: '',
  },
)
</script>

<template>
  <header class="portal-hero-header">
    <PortalBackButton class="portal-hero-header__back" :label="backLabel" />
    <div class="portal-hero-header__content">
      <small>{{ eyebrow }}</small>
      <h1>{{ title }}</h1>
      <p v-if="description">{{ description }}</p>
      <slot />
    </div>
  </header>
</template>

<style scoped>
.portal-hero-header {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 34px;
  gap: 8px;
  align-items: center;
  min-height: 48px;
  padding: max(8px, env(safe-area-inset-top)) 12px 8px;
  color: #222;
  background: #f7f7f7;
  border-bottom: 1px solid #e9e9e9;
}

.portal-hero-header__back {
  align-self: start;
  color: inherit;
}

.portal-hero-header__content {
  min-width: 0;
  text-align: center;
}

.portal-hero-header__content > small {
  display: none;
}

.portal-hero-header__content > h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.portal-hero-header__content > p {
  display: none;
}

@media (max-width: 359px) {
  .portal-hero-header {
    grid-template-columns: 32px minmax(0, 1fr) 32px;
  }
}
</style>
